export default __webpack_public_path__ + "img/a37255a67ec6cb98956b33e3a80da081.svg";